import axios from "axios";
import * as ActionTypes from "./actionTypes";
import * as urls from "../common/urls";

export function getProducts(page, pageSize, groupId, searchTerm) {
  const pagingParams = 
    page !== undefined && pageSize !== undefined ? `?page=${page}&pageSize=${pageSize}` : ``;

    let targetUrl = urls.PRODUCTS_URL;
    if (groupId) {
        targetUrl = urls.GROUP_PRODUCTS_URL.replace(":id", groupId)
    } else if (searchTerm) {
        targetUrl = urls.SEARCH_PRODUCTS_URL.replace(":searchTerm", searchTerm)
    }
    const url = `${targetUrl}${pagingParams}`;
  const request = axios.get(url);

  return { type: ActionTypes.GET_PRODUCTS, payload: request };
}

export function getFeaturedProducts(count) {
    const url = `${urls.FEATURED_PRODUCTS_URL}${count ? "5" : ""}`;
  const request = axios.get(url);

  return { type: ActionTypes.GET_FEATURED_PRODUCTS, payload: request };
}

export function getRelatedProducts(productId) {
    const url = `${urls.RELATED_PRODUCTS_URL}${productId}`;
  const request = axios.get(url);

  return {
    type: ActionTypes.GET_RELATED_PRODUCTS,
    payload: request
  };
}

export function getRecommendedProducts(productId) {
    const url = `${urls.RECOMMENDED_PRODUCTS_URL}${productId}`;
  const request = axios.get(url);

  return {
    type: ActionTypes.GET_RECOMMENDED_PRODUCTS,
    payload: request
  };
}

export function getProduct(id) {
   // console.log("axios", axios.defaults.headers.common);
  const url = `${urls.PRODUCTS_URL}${id}`;
  const request = axios.get(url);
  return { type: ActionTypes.GET_PRODUCT, payload: request };
}

//export function setActivePage(page) {
//  return { type: ActionTypes.SET_ACTIVE_PAGE, payload: page };
//}

//export function setPager(page, totalPages) {
//  return {
//    type: ActionTypes.SET_PAGER,
//    payload: { activePage: page, totalPages: totalPages }
//  };
//}
